export enum ECheckboxType {
  Box = "Box",
  BoxNew = "BoxNew",
  BoxList = "BoxList",
  InlineBox = "InlineBox",
  Toggle = "Toggle",
  CircleCheck = "CircleCheck",
  NewBox = "NewBox",
}
